import { useMutation } from 'react-query';
import {
  MetricsEventAPI,
  MetricsEventNames,
  MetricsEventOrigin,
} from 'api/metrics/events';

export const useMetricEventsMutation = (payload: {
  originId?: number;
  originType: MetricsEventOrigin;
  eventName: MetricsEventNames;
}) => {
  return useMutation(() => MetricsEventAPI.postMetricsEvent(payload));
};
